import React, { useState, useRef, useEffect } from 'react';
import { get } from 'lodash';
import { DateTime } from 'luxon';
import { compose } from 'recompose';

import { Grid, Typography, withStyles } from '@material-ui/core';
import { Trans } from '@lingui/macro';

import styles from './styles';
import Spacer from 'components/Spacer';
import { UserAvatar } from 'components';
import { icons } from 'components/WorkflowIcon';
import Button from 'components/Button';

const DraftIcon = icons.draft;

// naming is hard, util?
function useIsMountedRef() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

function ResolveRejection({ classes, itemCustomIdentifier, handleComplete, currentVersion, itemTypeMetadata }) {
  const rejectedBy = get(currentVersion, 'signingRejector');
  const rejectedAt = get(currentVersion, 'currentStatus.createdAt');
  const rejectedAtFormatted = `${DateTime.fromISO(rejectedAt).toFormat('MMMM d, yyyy')}.`;
  const [loading, setLoading] = useState(false);
  const isMountedRef = useIsMountedRef();

  return (
    <>
      <Spacer factor={1} />
      <div className={classes.heading}>
        <Typography variant="h3">
          <Trans>Resolve Rejection</Trans>
        </Typography>
      </div>

      <Spacer factor={2} />

      <Typography variant="body1">
        {`${itemCustomIdentifier} `}
        {itemTypeMetadata.name !== 'change_order' /* shhhh its fine */ && (
          <>
            <Trans>version</Trans> {get(currentVersion, 'versionIdentifier', '')}{' '}
          </>
        )}
        <Trans>was rejected on</Trans> {rejectedAtFormatted}
      </Typography>

      <Spacer factor={3} />

      <Typography variant="overline">
        <Trans>Rejected By</Trans>
      </Typography>
      <Spacer factor={2} />
      <Grid container>
        <Grid item xs={2} container direction="column" alignItems="flex-end">
          <div className={classes.padRightUnit}>
            <UserAvatar userId={rejectedBy.id} />
          </div>
        </Grid>
        <Grid item xs={10} style={{ marginTop: -4 }}>
          <Typography variant="body2">{rejectedBy.fullName}</Typography>
          <Typography variant="body2">{rejectedBy.title}</Typography>
        </Grid>
      </Grid>

      <Spacer factor={3} />

      <Typography variant="overline">
        <Trans>Reason for Rejection</Trans>
      </Typography>
      <Spacer factor={1} />
      <Typography variant="body2" className={classes.textInput}>
        {get(currentVersion, 'currentStatus.previousTransition.esignature.reasonForRejection', '')}
      </Typography>

      <Spacer factor={4} />
      <Button
        color="primary"
        className={classes.buttonDraft}
        fullWidth
        size="medium"
        type="submit"
        loading={loading}
        variant="contained"
        onClick={() => {
          setLoading(true);
          handleComplete().then(() => isMountedRef.current && setLoading(false));
        }}
      >
        <span className={classes.buttonIconText}>
          <DraftIcon className={classes.buttonIcon} />
          <Trans>Send Back To Draft</Trans>
        </span>
        <span style={{ flex: 2 }} />
      </Button>
    </>
  );
}

export default compose(withStyles(styles))(ResolveRejection);
